import Breadcrumb from 'components/breadcrumb'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import LoaderPopup from 'components/popUps/loaderInternalPopup'
import { useSession } from 'contexts/session-context'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import getEventById from 'views/events-info/utils'

interface RouteParams {
  id: string
}

const formatDate = (date: string) => {
  return dayjs(date).format('D [de] MMMM')
}

const Event = () => {
  const { id } = useParams<RouteParams>()
  const [event, setEvent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [{ data: session }] = useSession()

  const history = useHistory()

  useEffect(() => {
    const fetchEvent = async () => {
      if (!id) return

      setLoading(true)
      const data = await getEventById(id)
      setEvent(data)
      setLoading(false)
    }

    fetchEvent()
  }, [id])

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const imageUrl = windowWidth > 680 ? event?.thirdImageDesktopUrl : event?.thirdImageMobileUrl

  const styles = {
    background: `linear-gradient(180deg, rgba(2, 38, 14, 0) 0%, #02260E 100%), url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }

  if (loading) return <LoaderPopup />

  if (!event) return <p className="pt-12">No se encontró el evento.</p>

  const mimeTypes: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp'
  }

  const handleShare = async () => {
    const eventUrl = `${window.location.origin}/events/${event.id}`

    if (navigator.share) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const mimeType = blob.type;

        let fileExtension = 'jpg';
        if (mimeType && mimeTypes[mimeType]) {
          fileExtension = mimeTypes[mimeType];
        }

        const fileName = `${event.name}.${fileExtension}`;
        const file = new File([blob], fileName, { type: mimeType });

        const shareData = {
          files: [file],
          title: event.name,
          text: `¡Mira este evento! ${event.name}`,
          url: eventUrl
        }

        await navigator.share(shareData)
        dlTrackEvent('user_interaction', {
          action: 'click',
          element: 'share event',
          section: 'event detail'
        })
        console.log('Evento compartido exitosamente')
      } catch (error) {
        console.error('Error al compartir:', error)
      }
    } else {
      try {
        await navigator.clipboard.writeText(eventUrl)
        alert('Enlace del evento copiado al portapapeles')
      } catch (error) {
        console.error('Error al copiar el enlace:', error)
      }
    }
  }

  const handleRegister = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'register',
      section: 'event detail'
    })
    history.push('/start')
  }

  const handleDownloadId = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'download id',
      section: 'event detail'
    })
    history.push('/profile/identificacion')
  }

  const buttons = [
    {
      id: '13',
      nameNotLogin: 'Registrarme',
      nameLogin: 'Descargar mi Heineken ID',
      handleNotLogin: handleRegister,
      handleLogin: handleDownloadId
    },
    {
      id: 'default',
      nameNotLogin: 'Registrarme',
      nameLogin: 'Compartir',
      handleNotLogin: handleRegister,
      handleLogin: handleShare
    }
  ]

  const buttonProperties = buttons.find(button => button.id === id) ?? buttons.find((item) => item.id === 'default')

  return (
    <div className="event-info-id">
      <div className="event-info-id__container" style={styles}>
        <div className="event-info-id__bc">
          <Breadcrumb handleClick={() => history.goBack()} text="Eventos" />
        </div>
        <img src={`${AZURE_BASE_URL}/events/event-info-id.webp`} className="invisible" />

        <div className="event-info-id__container-text absolute bottom-0 left-0 w-full">
          <h2 className="event-info-id__title">{event.name}</h2>
          <p className="event-info-id__date">{formatDate(event.beginAt)}</p>
          {event.location && <p className="event-info-id__location">{event.location}</p>}
        </div>
      </div>

      <div className="event-info-id__container__bottom">
        <div className="event-info-id__bar" />

        <p className="event-info-id__text">{event.description ?? 'Sin información'}</p>

        <div className="event-info-id__bar" />

        <div className="event-info-id__buttons">
          <button className="event-info-id__share" onClick={session ? buttonProperties?.handleLogin : buttonProperties?.handleNotLogin}>
            <p>{session ? buttonProperties?.nameLogin : buttonProperties?.nameNotLogin}</p>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Event
